import React from 'react'
import PracticeCreationForm from '../registration/PracticeCreationForm'

const PracticeCreationPage = () => <PracticeCreationForm />

export default PracticeCreationPage
